// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25paK","clinicsSelect":"styles_clinicsSelect__sGFV_"};